import React from 'react'
import styled from 'styled-components'
import { RecipeLabels } from '../Kiosk/style'

const Icons = styled.span`
    margin-left: 2px;
`

const Icon = styled.img`
    width: ${props => props.size || '16px'};
    height: ${props => props.size || '16px'};
    vertical-align: text-top;
`

const nonAllergenTokens = 'Non-allergen'

const labelIcons = props => {
    let allergenProperties = [
        'Allergenes 1',
        'Allergenes 2',
        'Allergenes 3',
        'Allergenes 4',
        'Allergenes 5',
        'Allergenes 6',
        'Allergenes 7',
        'Allergenes 8',
        'Allergenes 9',
        'Allergenes 10',
    ]

    if (props.count) {
        allergenProperties = allergenProperties.slice(0, props.count)
    }

    const allergens = allergenProperties.reduce((result, item) => {
        if (
            props.item[item] &&
            !!props.item[item] &&
            props.item[item].indexOf(nonAllergenTokens) === -1
        ) {
            result.push(props.item[item])
        }
        return result
    }, [])
    const { dataSource } = props
    const isWinrest = dataSource === 'winrest' || dataSource === 'winrest2'

    if (allergens.length === 0) {
        return null
    }
    
    return (
        <RecipeLabels>
            <Icons>
                {allergens.map(item => (
                    <Icon
                        key={item}
                        src={
                            isWinrest
                                ? `img/allergens_winrest/${item.replace(
                                      /\//g,
                                      ''
                                  )}.png`
                                : `img/allergens/${item}.png`
                        }
                        alt={item}
                        size={props.size}
                        onError={i => (i.target.style.display = 'none')}
                    />
                ))}
                {/* {!!props.item.label && props.item.label !== '0' ? (
                <Icon
                    src={`img/labels/${props.item.label}.png`}
                    alt={props.item.label}
                    size={props.size}
                />
            ) : null} */}
            </Icons>
        </RecipeLabels>
    )
}

export default labelIcons
